let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("CoSDN")).then(() => parcelRequire('6zZXu'));